import * as Sentry from '@sentry/vue'
import configs from '@/config'
import utils from '@/util'
import { isFeatureEnabled } from '../featureToggles.module'

const aiChatbotKeyFlag = (rootState) => {
  if (!rootState.currentUser || rootState.currentUser?.isGuest) return null
  return `ai-chatbot-indicator-seen-${rootState.currentUser.id}`
}

const _state = {
  lastKnownPresentationId: null,
  isAIChatbotIndicatorVisible: false,
  isIframeReady: false,
}

const _getters = {
  canUseAIChatbot: (_, __, ___, rootGetters) => {
    return rootGetters['featureToggles/isFeatureEnabled']('release-ai-chatbot')
  },

  aiChatbotUrl: (state, __, rootState) => {
    const token = utils.getCookie('ahaToken')
    const currentPresentationId = rootState?.presentation?.id
    const userId = rootState?.currentUser?.id
    const userCity = rootState?.currentUser?.city

    // Use current presentation ID if available, otherwise use last known one
    // This fallback ensures the AI chatbot maintains context even when the presentation
    // state is temporarily unavailable (e.g., during navigation or state updates)
    const presentationId = currentPresentationId || state.lastKnownPresentationId
    const params = {
      presentationId, userId, userCity,
    }
    if (configs.env === 'local') {
      params.token = token
    }
    Object.keys(params).forEach((key) => params[key] == null && delete params[key])
    return `${window.location.protocol}//${configs.aiChatbotDomain}/?${new URLSearchParams(params).toString()}`
  },

  isAIChatbotIndicatorVisible: (state) => state.isAIChatbotIndicatorVisible,

  isIframeReady: (state) => state.isIframeReady,

  canOffAiBotMessagesInPresentationDetail: (_, __, ___, rootGetters) => {
    return isFeatureEnabled(rootGetters, 'release-AHA-36909-off-ai-bot-messages')
  },
}

const mutations = {
  SET_LAST_KNOWN_PRESENTATION_ID(state, presentationId) {
    state.lastKnownPresentationId = presentationId
  },

  CLEAR_LAST_KNOWN_PRESENTATION_ID(state) {
    state.lastKnownPresentationId = null
  },

  SET_IS_AI_CHATBOT_INDICATOR_VISIBLE(state, value) {
    state.isAIChatbotIndicatorVisible = value
  },

  SET_IS_IFRAME_READY(state, value) {
    state.isIframeReady = value
  },
}

const actions = {
  setLastKnownPresentationId({ commit }, presentationId) {
    commit('SET_LAST_KNOWN_PRESENTATION_ID', presentationId)
  },

  clearLastKnownPresentationId({ commit }) {
    commit('CLEAR_LAST_KNOWN_PRESENTATION_ID')
  },

  updateLastKnownPresentationId({ commit }, currentPresentationId) {
    if (currentPresentationId) {
      commit('SET_LAST_KNOWN_PRESENTATION_ID', currentPresentationId)
    }
  },

  checkAIChatbotIndicatorVisibilityAction({ commit, rootState }) {
    const key = aiChatbotKeyFlag(rootState)
    if (!key) return

    if (!localStorage.getItem(key)) {
      commit('SET_IS_AI_CHATBOT_INDICATOR_VISIBLE', true)
    }
  },

  markAIChatbotIndicatorSeenAction({ commit, rootState, rootGetters }) {
    if (!rootGetters['aiChatbot/isAIChatbotIndicatorVisible']) return
    const key = aiChatbotKeyFlag(rootState)
    if (!key) return

    try {
      localStorage.setItem(key, 'true')
      commit('SET_IS_AI_CHATBOT_INDICATOR_VISIBLE', false)
    } catch (error) {
      Sentry.captureException(error)
    }
  },

  setIsIframeReadyAction({ commit }, value) {
    commit('SET_IS_IFRAME_READY', value)
  },
}

export default {
  namespaced: true,
  state: _state,
  getters: _getters,
  mutations,
  actions,
}
